define('modules/editor/models/elements/popup',['require','exports','module','./base','../../services/popup_content/index'],function(require, exports, module) {
  "use strict";
  var BaseElement = require("./base"),
      PopupEditService = require("../../services/popup_content/index");

  module.exports = BaseElement.extend({
    name: "element:popup",
    defaultNameKey:"popup",
    defaultPropertyGroups: [],
    propertyGroups: [
      {
        name: "geometry",
        defaults: {
          height: "auto",
          width: 300,
          top: 0,
          left: 0
        }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "background",
        defaults: {
          color: "#ffffff",
          type: "solid",
          opacity: 0,
          imageUrl: "",
          secondColor: "#eeeeee",
          backgroundPosition: "left top",
          backgroundRepeat: "no-repeat",
          direction: "to left"
        }
      },
      {
        name: "border",
        defaults: {
          type: "none",
          width: 1,
          color: "#000000",
          position: "in",
          top: true,
          bottom: true,
          left: true,
          right: true,
          radius: 0
        }
      },
      {
        name: "popup:content",
        defaults: {
          "name": "",
          "title": "",
          "content": ""
        }
      }
    ],

    editPopup: function() {
      var currentName = this.getPropertyGroup("popup:content").get("name"),
      currentTitle = this.getPropertyGroup("popup:content").get("title"),
      currentContent = this.getPropertyGroup("popup:content").get("content");
      PopupEditService.editPopup(currentName, currentTitle, currentContent, _.bind(this.savePopup, this));
    },

    savePopup: function(name, title, content) {
      var popupParams = {
        name: name,
        title: title,
        content: content
      };
      this.getPropertyGroup("popup:content").set(popupParams);
    }
  });
});

